import type { VhAdminServicePlan } from '@/admin/admin.types';
import { SeatType } from '@/pages/SubscriptionSettingsPage/vessel-seats';
import { PAID_TIERS } from '@/store/subscriptions/subscriptions.types';

export const tierLabel = (tier: string) => tier.replace(/^./, (c) => c.toUpperCase());

export const isPaidTier = (tier?: string) => PAID_TIERS.some((paid) => paid === tier);

/**
 * "3 management · 2 crew", or null on Harbor: the server only counts seats against a paid plan,
 * so Harbor's stored numbers cap nothing.
 */
export const planSeatsLabel = (plan: VhAdminServicePlan | null | undefined) => {
  if (!plan || !isPaidTier(plan.tier)) return null;
  return `${plan.seats} management · ${plan.crew_seats} crew`;
};

const SEAT_LABELS: Record<string, string> = {
  [SeatType.HARBOR_SEAT]: 'Harbor seat',
  [SeatType.NAVIGATE_SEAT]: 'Management seat',
  [SeatType.COMMAND_SEAT]: 'Management seat',
  [SeatType.NAVIGATE_CREW]: 'Crew seat',
  [SeatType.COMMAND_CREW]: 'Crew seat',
};

export const seatLabel = (seatType?: string) =>
  (seatType && SEAT_LABELS[seatType]) || (seatType ? tierLabel(seatType) : 'No seat');
